const getImageAspectRatio = async (image: Blob) => {
  const bitmap = await createImageBitmap(image)
  return bitmap.width / bitmap.height
}

export default getImageAspectRatio
